/* Copyright (c) 2022-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Types } from 'bridge-commands/types';

export import GPUInfo = Types.Nvapp.Driverupdaterecommendation.GPUInfo;
export import GenericInfo = Types.Nvapp.Driverupdaterecommendation.GenericInfo;
export import SLIInfo = Types.Nvapp.Driverupdaterecommendation.SLI;

// Type alias for a single GPU object from the GPUInfo array
export type HardwareGPU = GPUInfo['GPU'][0];

export const defaultHardwareRefreshDebounceTime = 500;

// this will be later replaced by enum exposed from driver update recommendation plugin
// TODO to update as a part of https://jirasw.nvidia.com/browse/MVPC-13053
export enum MoboType {
    Laptop = 'Laptop',
    Notebook = 'Notebook',
    SubNotebook = 'Sub Notebook',
    Portable = 'Portable',
    Convertible = 'Convertible',
    Detachable = 'Detachable'
}

export const LaptopSpecificMoboTypeList: string[] = [
    MoboType.Laptop,
    MoboType.Convertible,
    MoboType.Detachable,
    MoboType.Notebook,
    MoboType.Portable,
    MoboType.SubNotebook
];
